import { ApproveReturnFieldsSchema } from "@redotech/redo-return-core-common/return-actions/approve-input";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const approveReturnInput = ApproveReturnFieldsSchema.extend({
  returnId: zExt.objectId(),
  sendNotification: z.boolean().optional(),
});

export const approveReturn = {
  name: "approveReturn" as const,
  input: approveReturnInput,
  output: z.null(),
};
